import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { apiEndpoints } from '../endpoints';
import { queryKeys } from '../react-query.config';

interface LeaderboardEntry {
  user_id: string;
  username: string;
  points: number;
  rank: number;
  selections?: any[];
  user?: {
    sso_user_id?: string;
    service_user_id?: string;
  };
}

interface PickemLeaderboardResponse {
  completedScoringCount: number;
  completedTournamentsScoringCount: number;
  selectionsCount: number;
  leaderboard: LeaderboardEntry[];
  pinedUserIds: string[];
}

export const getPickemLeaderboard = (pickemId: string): Promise<PickemLeaderboardResponse> =>
  api.get(apiEndpoints.getPickemLeaderboard(pickemId));

export const useGetPickemLeaderboardQuery = (pickemId?: string) => {
  return useQuery({
    queryKey: queryKeys.leaderboard.pickem(pickemId!),
    queryFn: () => getPickemLeaderboard(pickemId!),
    enabled: !!pickemId,
  });
};

export const downloadPickemLeaderboardCSV = async (pickemId: string): Promise<void> => {
  const response = await fetch(
    `${import.meta.env.VITE_API_BASE_URL}/api/admin/leaderboard/pickems/${pickemId}/export`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to download CSV');
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `pickem-${pickemId}-leaderboard.csv`;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};
